module.exports = __webpack_public_path__ + "static/img/tool-grey.e0a7f4b6.png";